export default {"src":"/_next/static/media/celebrate-icon.616285f6.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};